import React from 'react';
import { SiteFooter } from '@/components/SiteFooter';
import { LegalHeader } from './components/LegalHeader';

type LegalPageLayoutProps = {
  version: string;
  updatedAt: string;
  title: string;
  children: React.ReactNode;
};

export function LegalPageLayout({ version, updatedAt, title, children }: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <LegalHeader />
      <main className="flex-1">
        <div className="max-w-[720px] mx-auto px-6 py-10 md:py-14">
          <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-4 text-center">
              <p className="text-xs font-bold text-gray-600">
                {version} - {updatedAt}
              </p>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground">{title}</h1>
            </div>
            <div className="flex flex-col gap-10 text-sm md:text-base md:leading-6 text-gray-600">{children}</div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

export { LegalSection } from './components/LegalSection';
export { LegalParagraph } from './components/LegalParagraph';
export { LegalList } from './components/LegalList';
export { LegalEmailLink } from './components/LegalEmailLink';
export { LegalTable } from './components/LegalTable';
